import React, { useState } from 'react';
import { useStateContext } from '../../contexts/ContextProvider';

const OperationReportTemplates = () => {
        const { currentMode } = useStateContext();
        const [searchTerm, setSearchTerm] = useState('');
        const [currentPage, setCurrentPage] = useState(1);
        const [itemsPerPage, setItemsPerPage] = useState(10);
        const [filterType, setFilterType] = useState('All');

        // Sample template data - this would come from your backend
        const templates = [
                { id: 1, name: 'Lumbar - Right L4-S4 RFN + Caudal', type: 'Document' },
                { id: 2, name: 'Lumbar - Left L4-S4 RFN + Caudal', type: 'Document' },
                { id: 3, name: 'Cervical - Right C5-6 RFN + TFESI', type: 'Document' },
                { id: 4, name: 'Cervical - Left C5-6 RFN + TFESI', type: 'Document' },
                { id: 5, name: 'Thoracic - Right T7-8 RFN + TFESI', type: 'Document' },
                { id: 6, name: 'Thoracic - Left T7-8 RFN + TFESI', type: 'Document' },
                { id: 7, name: 'SI Joint - Right RFN', type: 'Document' },
                { id: 8, name: 'SI Joint - Left RFN', type: 'Document' },
                { id: 9, name: 'Knee - Right Genicular RFN', type: 'Document' },
                { id: 10, name: 'Knee - Left Genicular RFN', type: 'Document' },
        ];

        // Filter templates based on search term
        const filteredTemplates = templates.filter(template =>
                template.name.toLowerCase().includes(searchTerm.toLowerCase()) &&
                (filterType === 'All' || template.type === filterType)
        );

        // Calculate pagination
        const totalPages = Math.ceil(filteredTemplates.length / itemsPerPage);
        const startIndex = (currentPage - 1) * itemsPerPage;
        const endIndex = startIndex + itemsPerPage;
        const currentTemplates = filteredTemplates.slice(startIndex, endIndex);

        const handlePageChange = (page) => {
                setCurrentPage(page);
        };

        const handleAddTemplate = () => {
                // Navigate to template creation form
                console.log('Navigate to template creation');
        };

        return (
                <div className="p-6 bg-white dark:bg-gray-900 min-h-screen">
                        <div className="mb-8">
                                <div className="flex justify-between items-center mb-6">
                                        <h1 className="text-2xl font-semibold text-gray-900 dark:text-white">Operation Report Templates</h1>
                                        <button
                                                onClick={handleAddTemplate}
                                                className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        >
                                                Add Template
                                        </button>
                                </div>

                                {/* Tabs */}
                                <div className="flex space-x-2 mb-6">
                                        <button
                                                className={`px-4 py-2 rounded-full text-sm font-medium ${true ? 'bg-blue-900 text-white' : 'bg-gray-100 text-gray-600'
                                                        }`}
                                        >
                                                Current Templates
                                        </button>
                                        <button
                                                className="px-4 py-2 rounded-full text-sm font-medium bg-gray-100 text-gray-600 hover:bg-gray-200"
                                        >
                                                New Template Library
                                        </button>
                                </div>

                                {/* Search Bar */}
                                <div className="flex gap-2 mb-6">
                                        <div className="flex-1 relative">
                                                <input
                                                        type="text"
                                                        placeholder="Type name of template"
                                                        value={searchTerm}
                                                        onChange={(e) => setSearchTerm(e.target.value)}
                                                        className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                                                />
                                                <div className="absolute inset-y-0 right-0 flex items-center pr-3">
                                                        <svg className="h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                                                        </svg>
                                                </div>
                                        </div>
                                        <select
                                                value={filterType}
                                                onChange={(e) => setFilterType(e.target.value)}
                                                className="px-4 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                                        >
                                                <option value="All">All</option>
                                                <option value="Document">Document</option>
                                                <option value="Form">Form</option>
                                        </select>
                                </div>
                        </div>

                        {/* Templates Table */}
                        <div className="bg-white rounded-lg shadow overflow-hidden">
                                <table className="min-w-full divide-y divide-gray-200">
                                        <thead className="bg-gray-50">
                                                <tr>
                                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                                Name
                                                        </th>
                                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                                Type
                                                        </th>
                                                        <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                                Actions
                                                        </th>
                                                </tr>
                                        </thead>
                                        <tbody className="bg-white divide-y divide-gray-200">
                                                {currentTemplates.map((template) => (
                                                        <tr key={template.id}>
                                                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                                                        {template.name}
                                                                </td>
                                                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                                                        {template.type}
                                                                </td>
                                                                <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                                                                        <div className="flex justify-end space-x-2">
                                                                                <button className="text-blue-600 hover:text-blue-900">
                                                                                        <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                                                                                        </svg>
                                                                                </button>
                                                                                <button className="text-blue-600 hover:text-blue-900">
                                                                                        <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                                                                                        </svg>
                                                                                </button>
                                                                                <button className="text-blue-600 hover:text-blue-900">
                                                                                        <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                                                                        </svg>
                                                                                </button>
                                                                        </div>
                                                                </td>
                                                        </tr>
                                                ))}
                                        </tbody>
                                </table>
                        </div>

                        {/* Pagination */}
                        <div className="flex items-center justify-between px-4 py-3 bg-white border-t border-gray-200 sm:px-6">
                                <div className="flex items-center">
                                        <button
                                                onClick={() => handlePageChange(currentPage - 1)}
                                                disabled={currentPage === 1}
                                                className="mr-2 px-2 py-1 border border-gray-300 rounded-md disabled:opacity-50"
                                        >
                                                Previous
                                        </button>
                                        {[...Array(totalPages)].map((_, i) => (
                                                <button
                                                        key={i + 1}
                                                        onClick={() => handlePageChange(i + 1)}
                                                        className={`mx-1 px-3 py-1 rounded-md ${currentPage === i + 1 ? 'bg-blue-600 text-white' : 'border border-gray-300'
                                                                }`}
                                                >
                                                        {i + 1}
                                                </button>
                                        ))}
                                        <button
                                                onClick={() => handlePageChange(currentPage + 1)}
                                                disabled={currentPage === totalPages}
                                                className="ml-2 px-2 py-1 border border-gray-300 rounded-md disabled:opacity-50"
                                        >
                                                Next
                                        </button>
                                        <select
                                                value={itemsPerPage}
                                                onChange={(e) => setItemsPerPage(Number(e.target.value))}
                                                className="ml-4 px-2 py-1 border border-gray-300 rounded-md"
                                        >
                                                <option value={10}>10</option>
                                                <option value={20}>20</option>
                                                <option value={50}>50</option>
                                        </select>
                                        <span className="ml-4 text-sm text-gray-500">
                                                {startIndex + 1} - {Math.min(endIndex, filteredTemplates.length)} of {filteredTemplates.length} items
                                        </span>
                                </div>
                        </div>
                </div>
        );
};

export default OperationReportTemplates;